import { useEffect, useState } from "react";
import { Modal } from "../Component/Modal";
import { InputMoney } from "./InputMoney";
import { BasicButton } from "../Component/BasicButton";
import { toast } from "react-toastify";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../Component/PrintJson";

interface Props {
    renderValue?: number;
    onChange?: (total: number) => void;
    label?: string;
}

export const MultiInputMoney = ({ label, onChange, renderValue }: Props) => {
    const [modal, setModal] = useState<any>({
        tabIndex: -1,
        view: false,
        btnClose: true,
        btnSubmit: true,
        format: 'modal-md'
    });

    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!initialized && renderValue !== undefined && renderValue !== null && renderValue > 0) {
            setValues([renderValue]);
            setInitialized(true);
        }
    }, [renderValue, initialized]);


    const [values, setValues] = useState<number[]>([0]);

    const handleValueChange = (index: number, newValue: number) => {
        const updated = [...values];
        updated[index] = newValue;
        setValues(updated);

        const total = updated.reduce((acc, val) => acc + val, 0);
        if (onChange) onChange(total);
    };

    const handleAddInput = () => {
        setValues([...values, 0]);
    };

    const handleRemoveInput = (index: number) => {
        if (values.length > 1) {

            const updated = values.filter((_, i) => i !== index);
            setValues(updated);

            const total = updated.reduce((acc, val) => acc + val, 0);
            if (onChange) onChange(total);
        } else {
            toast.error("debe haber minimo un valor")
        }
    };

    const total = values.reduce((acc, val) => acc + val, 0);

    const properties = _single.getMoneyFormater();

    return (
        <>
            <label>{label ?? " "}</label>
            <input
                type="text"
                className="form-control"
                readOnly
                placeholder="$...."
                value={total.toLocaleString(properties.Locale, { style: "currency", currency: properties.Currency })}
                onClick={() => setModal({ ...modal, view: true, name: `valores ${label ?? ""}` })}
            />


            <Modal modal={modal} updateModal={setModal}>
                <div className="row">
                    <div className="col-12 mb-2">
                        <BasicButton eventClick={handleAddInput} icon="" children={"Agregar Valor"} />
                    </div>
                    {values.map((val, index) => (
                        <div className="col-12 mb-2 d-flex gap-2 align-items-center" key={index}>
                            <div className="flex-grow-1">
                                <InputMoney
                                    _value={val}
                                    onChange={(newVal: number) => handleValueChange(index, newVal)}
                                />
                            </div>
                            <div>
                                <button
                                    className="btn btn-outline-danger"
                                    onClick={() => handleRemoveInput(index)}
                                    title="Eliminar valor"
                                >
                                    ❌
                                </button>
                            </div>
                        </div>
                    ))}
                    <div className="col-12 mt-3">
                        <strong>Total: </strong>
                        {total.toLocaleString(properties.Locale, { style: "currency", currency: properties.Currency })}
                    </div>
                </div>
            </Modal>
        </>
    );
};
